import { Accordion, Col, Row } from 'react-bootstrap';
import { RxCross1 } from 'react-icons/rx';
import '../../styles/user/main.scss';
import '../../styles/user/order-history-detail.scss';
import { orderStatus, orderStatusMappings, paymentMethod, rePayOrderStatuses } from '../../types/order';
import { useEffect, useState } from 'react';
import { ProductLazyLoadImg } from '../../components/user/ProductImg';
import { language } from '../../language';
import { useSelector } from 'react-redux';
import { apiPost } from '../../apis';
import { useMsal } from '@azure/msal-react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { PaymentOptions } from '../../components/user/PaymentOptions';
import Swal from 'sweetalert2';
import { paymentOptionFail } from '../../helpers/swal/cart';
import { bankingOptionMappings } from '../../types/payment';
import sls from 'react-secure-storage';
import StatusHistories from '../../components/user/StatusHistories';

const OrderHistoryDetail = (props) => {
  const slsHrMobileData = sls.getItem('slsHrMobileData');
  const [status, setStatus] = useState();
  const hrMobileLanguage = useSelector((state) => state.app.slsHrMobileLanguage);
  const { instance, accounts } = useMsal();
  const [showCartBtnLoading, setShowCartBtnLoading] = useState(false);
  const isToDisableTPPPApp = useSelector((state) => state.app.isToDisableTPPPApp);
  const navigate = useNavigate();
  const [isMinimized, setIsMinimized] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setStatus(props?.orderHistory?.orderStatus);
  }, [props?.orderHistory?.orderStatus]);

  const [isRePay, setIsRePay] = useState(false);
  const [isQrRePay, setIsQrRePay] = useState(false);
  const [isBankingRePay, setIsBankingRePay] = useState(false);
  const [isConfirmRePay, setIsConfirmRePay] = useState(true);
  const [showBankingOptions, setShowBankingOptions] = useState(false);
  const [bankOptionName, setBankOptionName] = useState('');
  const [canCancel, setCanCancel] = useState(false);

  // reset payment option on switch option
  useEffect(() => {
    setIsConfirmRePay(false);

    if (showBankingOptions && bankOptionName) {
      setIsConfirmRePay(true);
    }

    if (!showBankingOptions) {
      setIsConfirmRePay(true);
    }
  }, [showBankingOptions, bankOptionName]);

  useEffect(() => {
    setIsRePay(false);

    if (isQrRePay || isBankingRePay) {
      setIsRePay(true);
    }
  }, [isQrRePay, isBankingRePay]);

  useEffect(() => {
    (async () => {
      try {
        if (!props?.orderHistory) return;

        const orderedDate = moment(props?.orderHistory?.createdAt).format('DD MMM YYYY');
        const todayDate = moment().format('DD MMM YYYY');
        let canRePay = false;
        setIsQrRePay(false);
        setIsBankingRePay(false);

        if (orderedDate == todayDate) {
          canRePay = rePayOrderStatuses?.some((rp) => rp == props?.orderHistory?.orderStatus?.orderStatusId);
        }

        if (!canRePay) return;

        if (props?.orderHistory?.chargesPayment?.qrPromtpay) {
          setIsQrRePay(true);
        } else {
          setIsQrRePay(false);
        }

        if (props?.orderHistory?.chargesPayment?.authorizeUri) {
          setIsBankingRePay(true);
        } else {
          setIsBankingRePay(false);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [props?.orderHistory]);

  const rePay = async () => {
    try {
      if (!props?.orderHistory?.orderNumber) return;
      setShowCartBtnLoading(true);

      Swal.fire({
        title: language?.orderHistoryRepayAlert?.title?.[hrMobileLanguage],
        text: language?.orderHistoryRepayAlert?.message?.[hrMobileLanguage],
        icon: 'warning',
        confirmButtonText: language?.pay?.[hrMobileLanguage],
        confirmButtonColor: '#F97C89',
        showCancelButton: true,
        cancelButtonText: language?.close?.[hrMobileLanguage],
        cancelButtonColor: 'black',
        focusCancel: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (res) => {
        if (res.isConfirmed) {
          const getValidation = await apiPost({
            uri: `Order/repaymentvalidation?employeeId=${slsHrMobileData?.authUser?.employeeId || ''}`,
            msal: {
              instance: instance,
              accounts: accounts,
            },
          });

          if (!getValidation) {
            return await catchRepayOrder();
          }

          if (getValidation?.limitStatus) {
            Swal.fire({
              title: language?.warning?.[hrMobileLanguage],
              text: language?.homePage?.limitMessageFrist?.[hrMobileLanguage] + getValidation?.itemLimitPerMonth + language?.homePage?.limitMessageLast?.[hrMobileLanguage],
              icon: 'warning',
              confirmButtonText: language?.homePage?.btnOK?.[hrMobileLanguage],
              cancelButtonText: language?.homePage?.btnCancel?.[hrMobileLanguage],
              confirmButtonColor: 'black',
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              window.location.reload();
            });

            return;
          }

          if (isQrRePay || isBankingRePay) {
            const orderRes = await apiPost({
              uri: `Order/repayment`,
              payload: {
                'orderNumber': props?.orderHistory?.orderNumber,
                'paymentMethod': showBankingOptions ? paymentMethod?.banking : paymentMethod?.promptPay,
                'bankName': bankOptionName,
              },
              msal: {
                instance: instance,
                accounts: accounts,
              },
            });

            if (!orderRes) {
              return await catchRepayOrder();
            }

            if (showBankingOptions) {
              if (orderRes?.chargesPayment?.authorizeUri) {
                window.location.href = orderRes?.chargesPayment?.authorizeUri;
              }

              setTimeout(() => {
                catchRepayOrder();
              }, 1000 * 5);

              return;
            } else {
              navigate(`/order/qr-payment?qrUrl=${orderRes?.chargesPayment?.qrPromtpay}&startedDate=${orderRes?.chargesPayment?.created_at}&orderNumber=${orderRes?.orderNumber}`);
              return;
            }
          }

          setShowCartBtnLoading(false);
        }

        setShowCartBtnLoading(false);
      });
    } catch (error) {
      console.error(error);

      await catchRepayOrder();
    }
  };

  const catchRepayOrder = async () => {
    Swal.fire(paymentOptionFail).then((res) => {
      window.location.reload();
    });
  };

  const handleBackToHistories = () => {
    const url = new URL(window.location);
    url.searchParams.delete('orderNumber');
    window.history.pushState({}, '', url);

    props?.setShowHistories(true);
  };

  useEffect(() => {
    setCanCancel(false);
    if (status?.orderStatusId == orderStatus.toPay) {
      setCanCancel(true);
    }
  }, [status]);

  const cancelByUser = async () => {
    try {
      setShowCartBtnLoading(true);

      Swal.fire({
        title: language?.warning?.[hrMobileLanguage],
        text: language?.cancelOrderByUserWarningAlert?.[hrMobileLanguage],
        icon: 'warning',
        confirmButtonText: language?.cancelOrderByUser?.[hrMobileLanguage],
        confirmButtonColor: '#F97C89',
        showCancelButton: true,
        cancelButtonText: language?.close?.[hrMobileLanguage],
        cancelButtonColor: 'black',
        focusCancel: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (res) => {
        if (res.isConfirmed) {
          await apiPost({
            uri: `Order/cancelorder?orderNumber=${props?.orderHistory?.orderNumber || ''}`,
            msal: {
              instance: instance,
              accounts: accounts,
            },
          });

          Swal.fire({
            title: language?.warning?.[hrMobileLanguage],
            text: language?.cancelOrderByUserPostAlert?.[hrMobileLanguage],
            icon: 'success',
            confirmButtonText: language?.ok?.[hrMobileLanguage],
            confirmButtonColor: 'black',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            window.location.reload();
          });
        }

        setShowCartBtnLoading(false);
      });
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className="order-detail">
      <div className='order-detail-top-header'>
        <h3 className='py-3 text-center mx-4' >
          <span style={{ cursor: 'pointer', float: 'left' }} onClick={handleBackToHistories}>
            <RxCross1 style={{ fontSize: '26px' }} />
          </span>

          <span style={{ marginLeft: '-1rem' }}>{language?.order_N?.[hrMobileLanguage]} {props?.orderHistory?.orderNumber}</span>
        </h3>
      </div>

      <div className='container mt-4'>
        <Row>
          <Col xs={12} md={12} lg={8} xl={8} xxl={8} style={{ minHeight: '80vh' }}>
            <Row className="order-detail-list">
              {props?.orderHistory?.orderDetails?.map((v, i) => (
                <Col xs={12} className='mb-4' key={i}>
                  <div className="order-detail-item">
                    <Row className=''>
                      <Col xs={5} md={3} lg={3} xl={3} xxl={2}>
                        <div style={{ backgroundColor: '#F9F8F6', borderRadius: '1rem' }}>
                          <ProductLazyLoadImg className="item-img" imgId={v?.image} />
                        </div>
                      </Col>

                      <Col xs={7} md={9} lg={9} xl={9} xxl={10} className='mt-2'>
                        <p className='d-inline-block text-truncate mb-1 text-dark fw-bold' style={{ maxWidth: '88%' }}>{v?.productName}</p>

                        <Row className='d-flex align-items-center justify-content-center text-secondary'>
                          <Col className='col-8 pe-0'>
                            <div>
                              <span className='mx-2' style={{ fontSize: '14px' }}>{language?.homePage?.Cart?.Quantity?.[hrMobileLanguage]}:
                                <span className='text-dark fw-bold ms-2'>
                                  {v?.qty || 0}
                                </span>
                              </span>
                            </div>
                            <div>
                              <span className='mx-2' style={{ fontSize: '14px' }}>{language?.homePage?.Filter?.Size?.[hrMobileLanguage]}:
                                <span className='text-dark fw-bold ms-2'>
                                  {v?.size || 'N/A'}
                                </span>
                              </span>
                            </div>
                          </Col>
                          <Col className='col-4 ps-0'>
                            <span className='text-dark fw-bold'>{v?.price?.toLocaleString('en-US') || 0} ฿</span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className={`px-4 card-summary ${isMinimized && 'card-summary-minimized-shadow'}`}>
            <Row className='d-flex align-items-center justify-content-center'>
              <Col xs={12}>
                <Accordion className={`card-summary-minimize-accordion`} defaultActiveKey={"0"}>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='d-lg-none d-block' onClick={() => setIsMinimized(!isMinimized)}>
                      <span className="card-summary-minimize-btn" >&nbsp;</span>
                    </Accordion.Header>
                    <Accordion.Body className='p-0'>

                      <div>
                        <ul className="list-group list-group-flush">
                          <li className="list-group-item text-secondary">{language?.status?.[hrMobileLanguage]}: <span style={{
                            float: 'right', color: orderStatusMappings?.find((osm) =>
                              osm?.key == status?.orderStatusId)?.color,
                          }}>
                            <span style={{ float: 'right' }}>{orderStatusMappings?.find((osm) => osm?.key == status?.orderStatusId)?.displayLabel?.[hrMobileLanguage]}</span>

                            {(status?.orderStatusId == orderStatus.cancelled || status?.orderStatusId == orderStatus.pending) && (
                              <>
                                <br />
                                <small className='text-secondary' style={{ float: 'right' }}>
                                  {language?.note?.[hrMobileLanguage]}: {props?.orderHistory?.orderStatus?.orderHistories?.find((oh) => oh?.orderStatusId == status?.orderStatusId)?.note || ''}
                                </small>
                              </>
                            )}
                          </span></li>
                          <li className="list-group-item text-secondary">{language?.total?.[hrMobileLanguage]}: <span className='text-dark' style={{ float: 'right' }}>
                            <span className='text-dark fw-bold'>
                              {props?.orderHistory?.total?.toLocaleString('en-US') || 0} ฿
                            </span>
                          </span></li>
                          <li className="list-group-item text-secondary">{language?.payment?.[hrMobileLanguage]}: <span className='' style={{ float: 'right' }}>
                            {props?.orderHistory?.chargesPayment?.qrPromtpay ?
                              language?.promptPay?.[hrMobileLanguage] :
                              (bankingOptionMappings?.find((bom) => bom?.key == props?.orderHistory?.paymentMethod?.bankName)?.displayLabel?.[hrMobileLanguage] || language?.banking?.[hrMobileLanguage])
                            }
                          </span></li>

                          <StatusHistories currentOrderHistory={props?.orderHistory} />
                        </ul>
                      </div>

                      <>
                        {(!isToDisableTPPPApp && isRePay) ? (
                          <>
                            <div className={`my-3`}>
                              <PaymentOptions
                                showBankingOptions={showBankingOptions}
                                setShowBankingOptions={setShowBankingOptions}
                                bankOptionName={bankOptionName}
                                setBankOptionName={setBankOptionName}
                              />
                            </div>
                            {showCartBtnLoading ? (
                              <div className='mb-3 inline-btn-loader bg-red mt-2 float-box-shadow to-sake-btn pe-none animated-hover-btn'>
                                <Row>
                                  <Col className='col-12 p-0'>
                                    <span className="loader"></span>
                                  </Col>
                                </Row>
                              </div>
                            ) : (
                              <div className={`mb-3 px-5 py-2 order-detail-btn mt-4 ${isConfirmRePay ? 'bg-red' : 'bg-gray-disabled'} float-box-shadow animated-hover-btn`}
                                onClick={async () => {
                                  if (!isConfirmRePay) return;

                                  if (isRePay && isConfirmRePay) {
                                    await rePay();
                                    return;
                                  }
                                }}>
                                <Row>
                                  <Col className='col-12 p-0'>
                                    <h3 className='text-white my-2 text-center' style={{ whiteSpace: 'nowrap' }}>
                                      {language?.pay?.[hrMobileLanguage]}
                                    </h3>
                                  </Col>
                                </Row>
                              </div>
                            )}
                            {canCancel && (
                              <a href="#" style={{ color: 'grey', fontSize: '14px' }} className='mb-4 d-flex align-items-center justify-content-center' onClick={async () => await cancelByUser()}>{language?.cancelOrderByUser?.[hrMobileLanguage]}</a>
                            )}
                          </>
                        ) : (
                          <div className={`mb-3 px-5 py-2 order-detail-btn mt-4 bg-black float-box-shadow animated-hover-btn`}
                            onClick={async () => props?.setShowHistories(true)}>
                            <Row>
                              <Col className='col-12 p-0'>
                                <h3 className='text-white my-2 text-center' style={{ whiteSpace: 'nowrap' }}>
                                  {language?.close?.[hrMobileLanguage]}
                                </h3>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </>


                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default OrderHistoryDetail;
